/*global Cookies*/
(function ($) {
	$(function () {
		var $scrollTopButton = $(".scroll-to-top");
		$scrollTopButton.on("click", function () {
			window.scrollTo({ top: 0, behavior: "smooth" });
		});

		// Hide scroll button when at the top of the page.
		$(window).on("scroll", function () {
			const scrollTop = $(window).scrollTop();

			if (scrollTop) {
				$scrollTopButton.fadeIn();
			} else {
				$scrollTopButton.fadeOut();
			}
		});
	});
})(jQuery);
